import { render, staticRenderFns } from "./patrol-right.vue?vue&type=template&id=4b397952&scoped=true&"
import script from "./patrol-right.vue?vue&type=script&lang=js&"
export * from "./patrol-right.vue?vue&type=script&lang=js&"
import style0 from "./patrol-right.vue?vue&type=style&index=0&id=4b397952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b397952",
  null
  
)

export default component.exports